// extracted by mini-css-extract-plugin
module.exports = {"body":"Catalog_body__Fi_eo","body_baseCatalogsGrid":"Catalog_body_baseCatalogsGrid__Fq9Rb"};